import type { DueStatus } from '@/services/scheduleService';

interface InspectionDueBadgeProps {
  type: 'daily' | 'weekly' | 'monthly';
  status: DueStatus;
  label: string;
}

export function InspectionDueBadge({ type, status, label }: InspectionDueBadgeProps) {
  const colors: Record<DueStatus, string> = {
    overdue: 'bg-status-fail/10 text-status-fail border-status-fail/20',
    'due-today': 'bg-status-warning/10 text-status-warning border-status-warning/20',
    upcoming: 'bg-status-pass/10 text-status-pass border-status-pass/20',
    unknown: 'bg-gray-100 dark:bg-gray-700 text-gray-400 border-gray-200 dark:border-gray-600',
  };

  const typeLabel: Record<string, string> = {
    daily: 'D',
    weekly: 'W',
    monthly: 'M',
  };

  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold ${colors[status]}`}>
      <span className="font-bold">{typeLabel[type]}</span>
      {label}
    </span>
  );
}